import styles from "./journalcard.module.css";
import { AlertTriangle, Trash2, } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const JournalCard = ({ item, setDeleteId, setDeleteModalOpen }) => {
    return (<Link to={"/security/journal/details/" + item?.id} className={`${styles.JournalListCard}`}>
        <div className={`${styles.JournalImageSec}`}>
            <p>{item?.user_initial}</p>
        </div>
        <div className={`${styles.JournalDesSec}`}>
            <p className={`${styles.Date}`}>{dayjs(item?.date).format("MM/DD/YYYY")} {item?.is_unusual === 1 && <AlertTriangle />}</p>
            <div className={`${styles.SummCommBodyText}`} dangerouslySetInnerHTML={{ __html: item.description }}></div>
        </div>
        <button className={`${styles.DeleteJournalBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteId(item?.id); setDeleteModalOpen(true); }}><Trash2 /></button>
    </Link>);
};

export default JournalCard;